import React from 'react';
import { Loader2, ExternalLink, Globe, QrCode, Download, Copy, Printer } from 'lucide-react';
import { useDashboard } from './dashboardContext';

export default function QrPanel() {
  const { activeTab, cfg, copyPublicUrl, downloadPoster, downloadQr, posterBusy, publicPageUrl, qrSrc, section, storeTab } = useDashboard();
  return (
    <>
        {activeTab === 'manage' && section === 'store' && storeTab === 'identity' && cfg?.id && (
          <div className="mb-8 rounded-2xl border border-white/10 bg-white/5 overflow-hidden" data-testid="qr-panel">
            <div className="px-5 py-3 border-b border-white/10 flex items-center gap-2">
              <QrCode className="w-4 h-4 text-[var(--accent)]" />
              <p className="font-semibold text-white text-sm">QR kods — tiešā rezervācijas saite</p>
            </div>
            <div className="p-5 flex flex-col sm:flex-row items-center gap-5">
              <div className="bg-white rounded-xl p-3 shrink-0" data-testid="qr-image-wrap">
                <img src={qrSrc} alt="QR kods" className="w-36 h-36 block" data-testid="qr-image" />
              </div>
              <div className="min-w-0 flex-1 w-full">
                <p className="text-sm text-white/70 mb-2">
                  Izdrukā vai parādi šo QR kodu — klienti to noskenē un nonāk tieši tavā biznesa lapā, kur var rezervēt.
                </p>
                <div className="flex items-center gap-2 mb-4 rounded-lg bg-white/5 border border-white/10 px-3 py-2">
                  <Globe className="w-3.5 h-3.5 text-white/40 shrink-0" />
                  <span className="text-xs text-white/60 truncate" data-testid="qr-public-url">{publicPageUrl}</span>
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  <button onClick={downloadQr} className="inline-flex items-center gap-2 text-xs font-semibold px-3.5 py-2 rounded-full bg-[var(--accent)] text-[var(--accent-contrast)] hover:bg-[var(--accent-hover)] transition-colors" data-testid="qr-download-btn">
                    <Download className="w-3.5 h-3.5" /> Lejupielādēt PNG
                  </button>
                  <button onClick={copyPublicUrl} className="inline-flex items-center gap-2 text-xs font-semibold px-3.5 py-2 rounded-full border border-white/15 text-white/70 hover:bg-white/10 transition-colors" data-testid="qr-copy-link-btn">
                    <Copy className="w-3.5 h-3.5" /> Kopēt saiti
                  </button>
                  <a href={publicPageUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-xs font-semibold px-3.5 py-2 rounded-full border border-white/15 text-white/70 hover:bg-white/10 transition-colors" data-testid="qr-open-link-btn">
                    <ExternalLink className="w-3.5 h-3.5" /> Atvērt lapu
                  </a>
                </div>
                <div className="flex items-center gap-2 flex-wrap mt-3 pt-3 border-t border-white/10">
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-white/50"><Printer className="w-3.5 h-3.5" /> Izdrukājams plakāts "Skenē un rezervē":</span>
                  <button onClick={() => downloadPoster('a4')} disabled={posterBusy} className="inline-flex items-center gap-2 text-xs font-semibold px-3.5 py-2 rounded-full border border-white/15 text-white/80 hover:bg-white/10 transition-colors disabled:opacity-50" data-testid="poster-a4-btn">
                    {posterBusy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />} A4
                  </button>
                  <button onClick={() => downloadPoster('a5')} disabled={posterBusy} className="inline-flex items-center gap-2 text-xs font-semibold px-3.5 py-2 rounded-full border border-white/15 text-white/80 hover:bg-white/10 transition-colors disabled:opacity-50" data-testid="poster-a5-btn">
                    {posterBusy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />} A5
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
}
